import React, { useState } from "react";
import { Box, Button, Dialog, DialogTitle, Grid, styled } from "@mui/material";

export interface duplicateConflictCheckModalProps {
    props: {
        conflictDuplicateData: any;
        modalOpen: boolean;
        setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    };
}

const CancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
    float: "left",
    margin: "10px 20px",
});

const DuplicateConflictCheckModal: React.FC<duplicateConflictCheckModalProps> = ({ props }) => {

    const handleModalClose = () => {
        props.setModalOpen(false);
    };

    return (

        <Box>
            <Dialog open={props.modalOpen} onClose={handleModalClose}>
                <Box>
                    <DialogTitle sx={{ textAlign: "center" }}>
                        以下の競合店を削除してください
                    </DialogTitle>
                    <Box sx={{ margin: "30px" }}>
                        <Grid container spacing={1} alignItems="center">
                            {props.conflictDuplicateData.map((conflictData: any, index: number) => (
                            <Grid container key={index} spacing={1} alignItems="center" justifyContent="center" sx={{ marginBottom: "10px" }}>
                                <Grid item xs={2.5} sx={{ textAlign: "right" }}>チェーン名:</Grid>
                                <Grid item xs={3.5} sx={{ textAlign: "left" }}>{conflictData.bland_name}</Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>店名:</Grid>
                                <Grid item xs={4} sx={{ textAlign: "left" }}>{conflictData.tenpo_name}</Grid>
                            </Grid>  
                            ))}
                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                <CancelButton onClick={() => { handleModalClose(); }}>
                                    閉じる
                                </CancelButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Dialog>
        </Box>
    );
};

export default DuplicateConflictCheckModal;
